import { Check, FolderOpen, X } from "lucide-react";
import * as React from "react";

import { Button } from "@/components/ui/button";
import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";
import { useCreateWorkspaceMember, useDeleteWorkspaceInvite } from "@/queries/workspace";
import { WorkspaceInvite } from "@/types/workspace-invite";

interface WorkspaceInviteItemProps {
  invite: WorkspaceInvite;
  onAccept: () => void;
  onReject: () => void;
}

export const WorkspaceInviteItem: React.FC<WorkspaceInviteItemProps> = ({
  invite,
  onAccept,
  onReject,
}) => {
  const createWorkspaceMember = useCreateWorkspaceMember({});
  const deleteWorkspaceInvite = useDeleteWorkspaceInvite({
    message: "Invitation declined successfully",
  });

  const handleAccept = (e: React.MouseEvent) => {
    e.stopPropagation();
    createWorkspaceMember.mutate({ workspace_invite_id: invite.id });
    onAccept();
  };

  const handleReject = (e: React.MouseEvent) => {
    e.stopPropagation();
    deleteWorkspaceInvite.mutate(invite.id);
    onReject();
  };

  return (
    <div className="mx-1 mb-1 flex items-center justify-between gap-2 rounded-md bg-amber-50/60 px-2.5 py-2 transition-colors hover:bg-amber-50">
      <div className="flex min-w-0 items-center gap-2">
        <div className="flex size-5 flex-shrink-0 items-center justify-center rounded bg-amber-100/80">
          <FolderOpen className="size-3 text-amber-700" />
        </div>
        <div className="min-w-0 flex-1 overflow-hidden">
          <OverflowDisplayTooltip
            content={invite.workspace.name}
            className="block w-full text-xs font-medium text-gray-900"
          >
            {invite.workspace.name}
          </OverflowDisplayTooltip>
          <span className="block text-[10px] text-gray-500">Pending invite</span>
        </div>
      </div>
      <div className="flex flex-shrink-0 items-center gap-0.5">
        <Button
          variant="ghost"
          size="tinyIcon"
          onClick={handleAccept}
          isLoading={createWorkspaceMember.isLoading}
          className="h-5 w-5 rounded text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700"
        >
          <Check className="h-3 w-3" />
        </Button>
        <Button
          variant="ghost"
          size="tinyIcon"
          onClick={handleReject}
          isLoading={deleteWorkspaceInvite.isLoading}
          className="h-5 w-5 rounded text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        >
          <X className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
};
